import React from 'react';
import { AdditionalFields, RequiredType } from '@rabbit/helper';
import { CommonInputBuilder } from './CommonInputBuilder';

interface DynamicFormBuilderProps {
  fields: AdditionalFields;
}

const CommonFormBuilder: React.FC<DynamicFormBuilderProps> = ({ fields }) => {
  return (
    <div className="w-full space-y-5">
      {Object.entries(fields).map(([key, field]) => (
        <CommonInputBuilder
          field={field}
          key={key}
          name={key}
          requiredType={
            field.validation?.required === RequiredType.REQUIRED_FOR_ALL
              ? RequiredType.REQUIRED_FOR_ALL
              : RequiredType.REQUIRED_FOR_CONSUMER
          }
        />
      ))}
    </div>
  );
};

export default CommonFormBuilder;
